export default __webpack_public_path__ + "static/media/projectHeader.47cd335c.png";